<template>
    <div class="background">
        <div class="color-picker picker"
             ref="backgroundselect"
             @click.stop="openPopup"
             :style="{
             backgroundColor:
             '#' +
             this.productInfo.palettecolors.find(
             (p)=>
            p.flossId == this.userProduct.bgFlossId
            ).flossHtml,
            backgroundImage:
            'url(' +
            (this.productInfo.backgroundimages.find(
            (p)=>
            p.backgroundImageId == this.userProduct.bgImageId
            ) ? this.productInfo.backgroundimages.find(
            (p)=>
            p.backgroundImageId == this.userProduct.bgImageId
            ).backgroundImageUrl : '')


            + ')',
            }"
            :title="
            this.productInfo.backgroundimages.find(
            (p)=>
            p.backgroundImageId == this.userProduct.bgImageId
            ) ?
            this.productInfo.backgroundimages.find(
            (p)=>
            p.backgroundImageId == this.userProduct.bgImageId
            ).backgroundImageName :
            'Background Color : ' +
            this.productInfo.palettecolors.find(
            (p) => p.flossId == this.userProduct.bgFlossId
            ).flossName
            "
            >
            <span>{{this.productInfo.palettecolors.find(p => p.flossId == this.userProduct.bgFlossId).flossName}}</span>
        </div>
        <div v-if="active == true" class="popup">
            <div class="popup-content">
                <h3>Solid Background</h3>
                <PaletteColors ref="paletteColors"
                               :flossId="userProduct.bgFlossId"
                               @change-color="setColor" />
                <h3>Pattern Background</h3>
                <BackgroundImages ref="backgroundImages"
                                  @change-background-image="setBackgroundImage"
                                  :backgroundImageId="userProduct.bgImageId" />

            </div>
            <div class="overlay" @click="active = false"></div>
        </div>
    </div>
</template>
<script>
    import PaletteColors from "@/components/PaletteColors.vue";
    import BackgroundImages from "@/components/BackgroundImages.vue";
    import { mapState } from "vuex";
    import Globals from "../globals";
    import UserProduct from "../objects/UserProduct";
    export default {
        name: "Background",
        data() {
            return {
                active: false,
                popupopen: false,
                hexColor: "",
            };
        },
        computed: {
            ...mapState(["productInfo", "userProduct"]),
        },
        destroyed() {
        },
        mounted() {
        },
        components: { PaletteColors, BackgroundImages },
        methods: {
            setColor(pcId) {
                this.$store.dispatch("setUserProductPaletteColor", pcId);
                this.$store.dispatch("setUserProductBackgroundImage", 0);
                this.$refs.paletteColors.selectedflossId = pcId;
                this.active = false;
            },
            setBackgroundImage(biId, biFile) {
                this.$store.dispatch("setUserProductBackgroundImage", biId);
                //this.$store.dispatch("setUserProductPaletteColor", 0);
                this.$refs.backgroundImages.selectedBackgroundImageId = biId;
                this.active = false;
            },
            openPopup: function (ev) {
                this.active = true;
                Globals.popupOpen = true;
            },
            closePopup: function () {
                this.$emit("close-popup");
            },
        },
    };
</script>
<style></style>
